import {API} from '@/plugins/finAmplifyModules'
import {sortedArchetypeClassifications, sortedArchetypes, sortedArchetypesPublic} from '@/js/finQueries'
import ArcheTypeFinder from '@/components/pages/onboarding/ArcheTypeFinder'

const state = {
  archetypeClassifications: null,
  archetypes: null,
  loadingArchetypes: true,
  loadingArchetypeClassification: true
}
const getters = {
  archetypeFinder: (state) => {
    return state.archetypes ? ArcheTypeFinder(state.archetypes) : null
  },
  loading: (state) => {
    return state.loadingArchetypes || state.loadingArchetypeClassification
  }
}

const mutations = {
  archetypeClassifications (state, archetypeClassifications) {
    state.archetypeClassifications = archetypeClassifications
  },
  archetypes (state, archetypes) {
    state.archetypes = archetypes
  },
  loadingArchetypes (state, loading) {
    state.loadingArchetypes = loading
  },
  loadingArchetypeClassification (state, loading) {
    state.loadingArchetypeClassification = loading
  }
}

const actions = {
  loadArchetypeClassifications ({ commit }) {
    return new Promise((resolve, reject) => {
      if (state.archetypeClassifications === null) {
        commit('loadingArchetypeClassification', true)
        API.graphql({query: sortedArchetypeClassifications, authMode: 'AWS_IAM'}).then(result => {
          commit('archetypeClassifications', result.data.searchArchetypeClassifications.items)
        }).catch(reject).finally(() => commit('loadingArchetypeClassification', false))
      }
    }
    )
  },

  loadArchetypesPublic ( { commit }) {
    return new Promise((resolve, reject) => {
      if (state.archetypes === null) {
        commit('loadingArchetypes', true)
        API.graphql({query: sortedArchetypesPublic, authMode: 'AWS_IAM'}).then(result => {
          commit('archetypes', result.data.searchArchetypes.items)
        }).catch(reject).finally(() => commit('loadingArchetypes', false))
      }
    })
  },

  loadArchetypes ( { commit }) {
    return new Promise((resolve, reject) => {
      if (state.archetypes === null) {
        commit('loadingArchetypes', true)
        API.graphql({query: sortedArchetypes}).then(result => {
          commit('archetypes', result.data.searchArchetypes.items)
        }).catch(reject).finally(() => commit('loadingArchetypes', false))
      }
    })
  }
}

export const archetype = {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
}
